// src/components/ContactButton.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './ContactButton.css';

const ContactButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const scrollToContact = () => {
    // Check if we're on the home page
    if (location.pathname === '/') {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        // Force all sections to render real content instead of content-visibility placeholders.
        document.querySelectorAll('.about, .evolution, .experience, .contact').forEach((el) => {
          el.style.contentVisibility = 'visible';
        });
        contactSection.querySelectorAll('.reveal:not(.visible)').forEach((el) => {
          el.classList.add('visible');
        });
        // Reflow so the browser recalculates positions with real heights.
        void contactSection.offsetTop;
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // On other pages, navigate to home page contact section
      // Store a flag in sessionStorage to indicate we need to scroll after navigation
      sessionStorage.setItem('scrollToContact', 'true');
      navigate('/');
    }
  };

  return (
    <button className="floating-contact-btn" onClick={scrollToContact} aria-label="Contact">
      <i className="fas fa-comment-dots"></i>
      <span className="btn-tooltip">Get in touch</span>
    </button>
  );
};

export default ContactButton;